const get = () => {
  const results = {
    id: 1,
    role: 'администратор',
    fullname: 'Иван Иванов',
    login: 'иванов1990',
    image_name: 'иванов.jpg',
  };
  return results;
};

export const useTokenPayload = {
  computed: {
    roleFromToken() {
      return get().role;
    },
    idFromToken() {
      return get().id;
    },
    fullnameFromToken() {
      return get().fullname;
    },
    login() {
      return get().login;
    },
    imageNameFromToken() {
      return get().image_name;
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useTokenPayload.js